import React from 'react';
import Header from "../../components/layout/Header";
// import CategoryList from "../../components/home/CategoryList";
import Banner from "../../components/home/Banner";
import Footer from "../../components/layout/Footer";

const Appliances = () => {
    const banners = [
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/3295c5100085a363.jpg?q=20",
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/36735235f3da1176.jpg?q=20",
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/d34fc9b3a0429712.jpg?q=20",
    ];

    return (
        <div style={{ backgroundColor: '#f1f2f4', minHeight: '100vh', paddingTop: '128px' }}>
            <Header />
            {/* <CategoryList /> */}

            <div style={{ maxWidth: '1440px', margin: '0 auto', padding: '12px 16px' }}>

                {/* Hero Banner (Auto Slider) */}
                <div style={{ marginBottom: '24px', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
                    <Banner images={banners} height="300px" />
                </div>

                {/* Seasonal Store - Large Cards */}
                <div style={{ marginBottom: '32px' }}>
                    <h2 style={{ fontSize: '24px', marginBottom: '24px', fontWeight: '800' }}>Summer Savings Store</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '32px' }}>
                        {[
                            { title: "Air Conditioners", off: "UP TO 50% OFF", img: "https://rukminim1.flixcart.com/image/416/416/xif0q/air-conditioner/q/a/a/-original-imahf4r9f9gzshge.jpeg?q=70" },
                            { title: "Refrigerators", off: "MIN. 40% OFF", img: "https://rukminim1.flixcart.com/image/416/416/xif0q/refrigerator/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" }
                        ].map((item, i) => (
                            <div
                                key={i}
                                style={{
                                    backgroundColor: 'white',
                                    borderRadius: '28px',
                                    padding: '40px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.4s'
                                }}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px' }}>
                                    <span style={{ backgroundColor: '#e6fffa', color: '#2b6cb0', padding: '4px 16px', borderRadius: '999px', fontSize: '12px', fontWeight: '800' }}>{item.off}</span>
                                    <h3 style={{ fontSize: '20px', fontWeight: '900', margin: 0 }}>{item.title}</h3>
                                    <p style={{ color: '#718096', fontWeight: '600', margin: 0 }}>Premium Range | 2024 Models</p>
                                    <button style={{ backgroundColor: '#2b6cb0', color: 'white', border: 'none', borderRadius: '999px', padding: '0 48px', height: '48px', fontWeight: '800', cursor: 'pointer' }}>Explore Now</button>
                                </div>
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    style={{ height: '200px', objectFit: 'contain' }}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Smaller Utility Store */}
                <div style={{ marginBottom: '48px' }}>
                    <h2 style={{ fontSize: '24px', marginBottom: '24px', fontWeight: '800' }}>Kitchen & Utility Essentials</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '24px' }}>
                        {[
                            { item: "Juicers", img: "https://rukminim1.flixcart.com/image/612/612/xif0q/mixer-grinder-juicer/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" },
                            { item: "Microwaves", img: "https://rukminim1.flixcart.com/image/612/612/xif0q/microwave-oven/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" },
                            { item: "Irons", img: "https://rukminim1.flixcart.com/image/612/612/xif0q/iron/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" },
                            { item: "Vacuum", img: "https://rukminim1.flixcart.com/image/612/612/xif0q/vacuum-cleaner/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" },
                            { item: "Purifiers", img: "https://rukminim1.flixcart.com/image/612/612/xif0q/water-purifier/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" },
                            { item: "Fans", img: "https://rukminim1.flixcart.com/image/612/612/xif0q/fan/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" }
                        ].map((utility, i) => (
                            <div key={i} style={{ backgroundColor: 'white', padding: '24px', borderRadius: '28px', cursor: 'pointer', textAlign: 'center', transition: '0.3s', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div style={{ width: '120px', height: '120px', backgroundColor: '#f8faff', padding: '16px', border: '1px solid #eef2f6', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img src={utility.img} alt={utility.item} style={{ height: '100%', objectFit: 'contain' }} />
                                </div>
                                <p style={{ fontWeight: '800', marginTop: '16px', fontSize: '14px', color: '#212121', marginBottom: '4px' }}>{utility.item}</p>
                                <p style={{ color: '#388e3c', fontWeight: '900', fontSize: '13px', margin: 0 }}>Min. 30% Off</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Brand Selection Section */}
                <div style={{ backgroundColor: 'white', borderRadius: '28px', padding: '32px', marginBottom: '48px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                    <h2 style={{ fontSize: '22px', marginBottom: '32px', fontWeight: '800' }}>Partner Brands</h2>
                    <div style={{ display: 'flex', gap: '48px', overflowX: 'auto', paddingBottom: '16px', justifyContent: 'center' }}>
                        {["Samsung", "LG", "Whirlpool", "Haier", "Bosch", "Panasonic"].map((brand, i) => (
                            <div key={i} style={{ minWidth: '140px', cursor: 'pointer', transition: '0.3s', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div style={{ backgroundColor: '#fffcf5', border: '2px solid #fff3cd', borderRadius: '20px', padding: '24px', width: '100%', textAlign: 'center' }}>
                                    <span style={{ fontWeight: '900', fontSize: '16px', color: '#856404' }}>{brand.toUpperCase()}</span>
                                </div>
                                <p style={{ fontSize: '12px', color: '#718096', marginTop: '8px', fontWeight: '700' }}>AUTHORISED RETAILER</p>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    );
};

export default Appliances;

